<div class="select-media-container">
  @if (selectedItem) {
    <div class="selected-media-block">
      <div class="image-block">
        <div class="image-preview" (click)="setShowPreview(true)">
          <img
            class="image-displayed"
            [src]="setSelectedItemBG(selectedItem.src)"
            (load)="imageLoaded()"
            />
            @if (checkIsSelectedItemImage()) {
              <div class="image-preview-hover"></div>
            }
            @if (!checkIsSelectedItemImage()) {
              <p class="no-preview-format">
                {{ selectedItem.type }}
              </p>
            }
          </div>
          <div class="image-data">
            <p class="filename">{{ selectedItem.name }}</p>
            <p class="filesize">{{ setFilesize(selectedItem.size) }}</p>
          </div>
        </div>
        <div class="delete-media-btn-block" (click)="removeMedia()">
          Remove {{ imageOnly ? 'Image' : 'File' }}
        </div>
      </div>
    } @else {
      <div class="select-media-block">
        @if (mediaUploaded) {
          <div class="image-block" [ngClass]="imageOnly ? 'image' : 'file'"></div>
        } @else {
          <loading-icon></loading-icon>
        }
        <div class="add-image-btn-block" (click)="setIsModalOpen(true)">
          <span class="plus">+ </span>Add {{ imageOnly ? 'Image' : 'File' }}
        </div>
      </div>
    }
  </div>


  @if (isModalOpen) {
    <div class="assets-table-container">
      <div class="assets-table-block">
        <div class="assets-table-header">
          <div class="assets-table-title">Asset Library</div>
          <div class="assets-table-close-btn" (click)="setIsModalOpen(false)"></div>
        </div>
        <div class="assets-table-content">
          <div class="assets-library-top-panel">
            <label>
              <div class="assets-searchBox">
                <input
                  class="searchBtn"
                  placeholder="Search"
                  type="text"
                  #searchFor
                  value=""
                  (input)="searchForChange(searchFor)"
                  [(ngModel)]="searchValue"
                  />
                  @if (searchFor.value) {
                    <div
                      mat-button
                      matSuffix
                      mat-icon-button
                      aria-label="Clear"
                      (click)="searchFor.value = ''; searchForValue = ''"
                      class="assets-searchBoxDelete"
                    ></div>
                  }
                </div>
              </label>
            </div>
            <div class="table-container">
              <assets-table
                [imageOnly]="imageOnly"
                [mediaFilter]="mediaFilter"
                [menuHeader]="menuHeader"
                [searchValue]="searchValue"
                [canEdit]="canEdit"
                [canSelect]="canSelect"
                [assetsStatus]="assetsStatus"
                (checkAssets)="checkAssets($event)"
                (onSelectAsset)="selectAssetHandler($event)"
                (getImagesLength)="getImagesLength($event)"
              ></assets-table>
            </div>
          </div>
          <div class="assets-library-bottom-panel">
            <div class="assets-library-bottom-panel-left">
              <button class="btn upload-btn" (click)="uploadNewAsset($event)" [style.visibility]="showUpload ? 'visible' : 'hidden'">Upload</button>
            </div>
            <div class="assets-library-bottom-panel-right">
              <div class="btn cancel-btn" (click)="setIsModalOpen(false)">Cancel</div>
              <button class="btn add-btn" (click)="addAsset()" [disabled]="!checkIsAssetSelected()">
                Add Asset
              </button>
            </div>
          </div>
        </div>
      </div>
    }

    @if (showPreview) {
      <div class="popup-container">
        <div class="popup-block">
          <div class="popup-header">
            <div class="close-btn" (click)="setShowPreview(false)"></div>
          </div>
          <div class="popup-body">
            <img [src]="selectedItem.src" [alt]="selectedItem.name" class="preview" />
          </div>
        </div>
      </div>
    }

    <upload-asset
      [startUpload]="showUploadModal"
      (cancelUploadEvHandler)="cancelUpload()"
      (finishUploadEvHandler)="finishUpload()"
    ></upload-asset>

